import Icon from 'snippets/icon/icon'

function CustomModalDialog({
  header,
  content,
  footer,
  id,
  type = 'modal',
  classClose = 'w-8 h-8 p-2',
  classMain = '',
  classContent = '',
  classHeader = '',
  classModalDialog = '',
  title,
  scrollTarget = '.modal-dialog-inner'
}) {
  return (
    <modal-dialog
      data-target={id}
      data-type={type}
      data-scroll-target={scrollTarget}
      className={classModalDialog}
    >
      <div class="modal-dialog-overlay" />
      <div
        className={`modal-dialog-content js-content-modal-dialog relative ${classMain}`}
        aria-modal="true"
        role="dialog"
        aria-label={title && title}
      >
        <div className={`relative ${classHeader}`}>
          {header}
          <button
            type="button"
            className={`js-close-modal-dialog absolute right-5 top-5 size-4 ${classClose}`}
            aria-label="close modal"
          >
            <Icon name="icon-close-outline" className="h-4 w-4 text-neutral-700" viewBox="0 0 20 20" />
          </button>
        </div>
        <div className={`modal-dialog-inner ${classContent}`}>{content}</div>
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
